module.exports = __webpack_public_path__ + "img/404_text.206d66fc.png";